import ApplicationAdapter from './application';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';

export default class AccountUsageAdapter extends ApplicationAdapter {
  @service account!: AccountService;

  queryRecord() {
    let url = `${this.buildURL('account', this.account.current.id)}/usage`;
    return this.ajax(url, 'GET', {});
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'account-usage': AccountUsageAdapter;
  }
}
